import { Paper } from "@material-ui/core";
import styled from 'styled-components';

export const Container = styled(Paper)`
  display: flex;
  flex-direction: column;
  padding: 16px;
  border-radius: 8px;
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ccc;
`;

export const CloseButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
`;

export const FilePropertiesContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 6px;
`;

export const FilePropertyRow = styled.div`
  display: grid;
  grid-template-columns: 34% 66%;
  margin-bottom: 8px;
  word-wrap: break-word;
`;

export const FilePropertyTitle = styled.span`
  font-weight: bold;
`;

export const FilePropertyText = styled.span`
`;

export const CopyLinkButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const CopyFileLinkButton = styled.button`
  border: 1px solid #666666;
  border-radius: 8px; 
  padding: 8px;

  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;

  background-color: transparent;

  :hover {
    background-color: #ededed;
    transition-delay: 0.1s;
  }
`;

export const CloseCopiedLinkPopoverButton = styled.button`
  cursor: pointer;
  
  background-color: transparent;
  color: #fff;
  
  border: 0px;
  border-radius: 50%;
  
  width: 40px;
  height: 40px;

  display: flex;
  align-items: center;
  justify-content: center;

  :hover {
    background-color: #484848;
    transition-delay: 0.1s;
  }
`;
